import { Space, Badge } from 'antd';
import { useRequest } from 'ahooks';
import { getQuestionCount } from 'views/Mercado/FAQ/services';

export const MercadoNav = () => {
  const { data } = useRequest(getQuestionCount, {
    pollingInterval: 15 * 1000,
    pollingWhenHidden: false,
  });

  return (
    <Space>
      Q&A
      <Badge style={{ background: '#17C2FF' }} count={data} overflowCount={9999} />
    </Space>
  );
};
